import { render, staticRenderFns } from "./MagicLinkPost.vue?vue&type=template&id=fbb17c3c&scoped=true&"
import script from "./MagicLinkPost.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPost.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPost.vue?vue&type=style&index=0&id=fbb17c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb17c3c",
  null
  
)

component.options.__file = "MagicLinkPost.vue"
export default component.exports